import {
  FEEDBACK_CREATE,
  FeedBackRequest,
  FeedBackResponse,
} from "@project/shared-types";
import apiFetchPost from "../apiClient";

export const SendFeedBackAPI = async (dataRequest: FeedBackRequest) => {
  const response = await apiFetchPost<FeedBackRequest, FeedBackResponse>(
    FEEDBACK_CREATE,
    dataRequest
  );
  return response;
};
